module.exports = __webpack_public_path__ + "static/media/dropDownArrow.9eded659.svg";